const DeliveryPlanning = {

    // FIELDS
    "vehicle": "المركبة",
    "driver": "السائق",
    "description": "الوصف",
    "status": "الحالة",
    "dispatch_date": "تاريخ الإرسال",
    "customer": "العميل",
    "items": "العناصر",
    "lat": "خط العرض",
    "lng": "خط الطول",
    "dispatch_address": "عنوان الإرسال",
    "repeated_customer": "عميل مكرر",
    "alredy_exist": "العميل موجود بالفعل!!..",
    "item": "عنصر",
    "quantity": "كمية",
    "unit": "وحدة",
    "image": "صورة",

    // PAGE HEADER
    "delivery_planning": "تخطيط التسليم",

    // ERROR
    "error_vehicle": "اختر المركبة",
    "error_driver": "اختر السائق",
    "error_desc": "أدخل الوصف",
    "error_status": "اختر الحالة",
    "error_dispatch_date": "اختر تاريخ الإرسال",
    "error_customer": "اختر العميل",
    "error_lat": "أدخل خط العرض",
    "error_lng": "أدخل خط الطول",
    "error_dispatch_add": "اختر عنوان الإرسال",

    // TABLE HEADER
    "table_vehicle": 'المركبة',
    "table_description": "الوصف",
    "table_dispatch_date": "تاريخ الإرسال",
    "table_status": "الحالة",
}

export default DeliveryPlanning;